export const CHOOSE_NEED_HEADER = "choose_need_header";
export const FAMILY_PROFILE_HEADER = "family_profile_header";
export const CUSTOMIZATION_HEADER = "customization_header";
export const PREVIEW_SHARE_HEADER = "preview_share_header";
export const LA_PR_FAMILY_PROFILE = "la_pr_family_profile";
export const RECALCULATE_CUSTOMIZATION = "recalculate_customization";
export const VIEW_CASH_FLOW_CUSTOMIZATION = "view_cash_flow_customization";
export const VIEW_SALIENT_FEATURE_CUSTOMIZATION = "view_salient_feature_customization";
export const CHANGE_PRODUCT_CUSTOMIZATION = "change_product_customization";
export const ADD_NEED_CUSTOMIZATION = "add_need_customization";
export const ADD_ASSURED_CUSTOMIZATION= "add_assured_customization";
export const CHANGE_LA_CUSTOMIZATION = "change_la_customization";
export const CHANGE_PR_CUSTOMIZATION = "change_pr_customization";
export const VIEW_PROSPECTUS_PREVIEW_SHARE = "view_prospectus_preview_share";
export const VIEW_BI_PREVIEW_SHARE = "view_bi_preview_share";
export const SAVE_CLOSE = "save_close";
export const EXIT_TOOL = "exit_tool";
export const EDIT_QUOTE = "edit_quote";
export const START_APPLICATION = "start_application";
export const COMPARE_PRODUCTS = "compare_product";
export const COMPARE_BI_TABLE_PT = "compare_bi_pt";
export const COMPARE_BI_TABLE_PPT = "compare_bi_ppt";
export const COMPARE_BI_TABLE_PREMIUM = "compare_bi_premium";
export const VIEW_CASH_FLOW_CHART_CUSTOMIZATION = "view_cash_flow_chart_customization";
export const SHARE_ON_WHATSAPP = "share_on_whatsapp";
export const QMS_RESUME_ANALYSIS = "qms_resume_analysis";
export const QMS_DOWNLOAD_PDF =  "qms_download_pdf";
export const QMS_VIEW_QUOTE = "qms_view_quote";
export const QMS_RESUME_APPLICATION = "qms_resume_application";
export const QMS_VIEW_DETAILS = "qms_view_details";
export const QMS_UPLOAD_DOCUMENTS = "qms_upload_documents";
export const QMS_COMPLETE_PAYMENT = "qms_complete_payment";
export const QMS_RESUME = "qms_resume";
export const QMS_CUSTOMER_NAME = "qms_customer_name";
export const QMS_MOBILE_NUMBER = "qms_mobile_number";
export const QMS_EMAIL = "qms_email";
export const QMS_RH = "qms_rh";
export const QMS_CH = "qms_ch";
export const QMS_BH = "qms_bh";
export const QMS_DM = "qms_dm";
export const QMS_PFA = "qms_pfa";
export const QMS_TM = "qms_tm";
export const QMS_BM = "qms_bm";
export const QMS_RM = "qms_rm";
export const QMS_FROM_DATE = "qms_from_date";
export const QMS_TO_DATE = "qms_to_date";
export const QMS_PRODUCT = "qms_product";
export const QMS_SOLUTION_COVERAGE = "qms_solution_coverage";



